import React, { useState } from 'react';
import { ExternalLinkIcon } from 'lucide-react';
// Sample portfolio projects (replace with your actual work)
const projects = [{
  id: 1,
  title: 'Character Animation Reel',
  category: 'Character',
  thumbnail: 'https://images.unsplash.com/photo-1626544827763-d516dce335e2?q=80&w=1000&auto=format&fit=crop',
  description: 'Character animation showcase featuring various emotional expressions and movement styles.'
}, {
  id: 2,
  title: 'Product Visualization',
  category: 'Commercial',
  thumbnail: 'https://images.unsplash.com/photo-1617791160505-6f00504e3519?q=80&w=1000&auto=format&fit=crop',
  description: "3D product visualization for a tech company's latest device launch."
}, {
  id: 3,
  title: 'Architectural Walkthrough',
  category: 'Environment',
  thumbnail: 'https://images.unsplash.com/photo-1616587226157-48e49175ee20?q=80&w=1000&auto=format&fit=crop',
  description: 'Detailed architectural visualization and animated walkthrough of a modern building complex.'
}, {
  id: 4,
  title: 'Short Film: Beyond',
  category: 'Narrative',
  thumbnail: 'https://images.unsplash.com/photo-1534972195531-d756b9bfa9f2?q=80&w=1000&auto=format&fit=crop',
  description: 'Award-winning animated short film exploring themes of discovery and wonder.'
}, {
  id: 5,
  title: 'Game Cinematic',
  category: 'Game',
  thumbnail: 'https://images.unsplash.com/photo-1585504198199-20277ddc0c3b?q=80&w=1000&auto=format&fit=crop',
  description: 'Opening cinematic sequence for an indie game title.'
}, {
  id: 6,
  title: 'Abstract Animation',
  category: 'Experimental',
  thumbnail: 'https://images.unsplash.com/photo-1633280336716-2d5b0704b8bb?q=80&w=1000&auto=format&fit=crop',
  description: 'Experimental abstract animation exploring form, color, and movement.'
}];
// Categories for filtering
const categories = ['All', 'Character', 'Commercial', 'Environment', 'Narrative', 'Game', 'Experimental'];
export const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [selectedProject, setSelectedProject] = useState<null | (typeof projects)[0]>(null);
  const filteredProjects = activeCategory === 'All' ? projects : projects.filter(project => project.category === activeCategory);
  return <section id="portfolio" className="py-20 bg-gray-900" data-id="element-135">
      <div className="container mx-auto px-4" data-id="element-136">
        <h2 className="text-4xl font-bold mb-2 text-center" data-id="element-137">Portfolio</h2>
        <p className="text-gray-400 text-center mb-12" data-id="element-138">
          Check out my latest 3D animation projects
        </p>
        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-139">
          {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`px-4 py-2 rounded-full text-sm transition-colors ${activeCategory === category ? 'bg-indigo-600 text-white' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`} data-id="element-140">
              {category}
            </button>)}
        </div>
        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-141">
          {filteredProjects.map(project => <div key={project.id} className="group relative overflow-hidden rounded-lg cursor-pointer" onClick={() => setSelectedProject(project)} data-id="element-142">
              <div className="aspect-video w-full overflow-hidden" data-id="element-143">
                <img src={project.thumbnail} alt={project.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-144" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex flex-col justify-end p-6" data-id="element-145">
                <h3 className="text-xl font-bold" data-id="element-146">{project.title}</h3>
                <p className="text-sm text-gray-300" data-id="element-147">{project.category}</p>
              </div>
            </div>)}
        </div>
        {/* Project Modal */}
        {selectedProject && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80" onClick={() => setSelectedProject(null)} data-id="element-148">
            <div className="bg-gray-800 max-w-4xl w-full rounded-lg overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-149">
              <div className="aspect-video w-full" data-id="element-150">
                <img src={selectedProject.thumbnail} alt={selectedProject.title} className="w-full h-full object-cover" data-id="element-151" />
              </div>
              <div className="p-6" data-id="element-152">
                <div className="flex justify-between items-start mb-4" data-id="element-153">
                  <div data-id="element-154">
                    <h3 className="text-2xl font-bold" data-id="element-155">
                      {selectedProject.title}
                    </h3>
                    <span className="inline-block px-3 py-1 bg-indigo-600/20 text-indigo-400 text-sm rounded-full mt-2" data-id="element-156">
                      {selectedProject.category}
                    </span>
                  </div>
                  <button onClick={() => setSelectedProject(null)} className="text-gray-400 hover:text-white" data-id="element-157">
                    <ExternalLinkIcon size={24} data-id="element-158" />
                  </button>
                </div>
                <p className="text-gray-300" data-id="element-159">{selectedProject.description}</p>
                <div className="mt-6 flex justify-end" data-id="element-160">
                  <button onClick={() => setSelectedProject(null)} className="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded text-sm" data-id="element-161">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>}
      </div>
    </section>;
};